import { render, staticRenderFns } from "./CreateDepartment.vue?vue&type=template&id=0ccba2a5&scoped=true"
import script from "./CreateDepartment.vue?vue&type=script&lang=js"
export * from "./CreateDepartment.vue?vue&type=script&lang=js"
import style0 from "./CreateDepartment.vue?vue&type=style&index=0&id=0ccba2a5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccba2a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ccba2a5')) {
      api.createRecord('0ccba2a5', component.options)
    } else {
      api.reload('0ccba2a5', component.options)
    }
    module.hot.accept("./CreateDepartment.vue?vue&type=template&id=0ccba2a5&scoped=true", function () {
      api.rerender('0ccba2a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employee/CreateDepartment.vue"
export default component.exports